import React from 'react';
import { IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Clear';

export function getCommonSelectProps(value: string | number, onClear: () => void) {
  return {
    IconComponent: (props: any) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingRight: '20px',
        }}
      >
        {value && (
          <IconButton
            aria-label="clear"
            size="small"
            onClick={e => {
              e.stopPropagation();
              onClear();
            }}
            sx={{
              position: 'absolute',
              right: '24px',
            }}
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
        <ArrowDropDownIcon {...props} />
      </div>
    ),
  };
}